<template>
  <div class="m-levels m-levels--static">
      <div class="m-level__wrap m-level__wrap--static"
       :key="level.level" v-for="level in getAllLevels">
        <span v-bind:class="'m-level__' + level.level"
          class="m-level m-level--completed m-level--static">
          <span class="m-level__number m-level__number--static"
            v-bind:class="'m-level__number--' + level.level">
            {{ level.level }}
          </span>
        </span>
        <span v-if="level.level < getAllLevels.length"
         class="m-level__bar m-level__bar--completed m-level__bar--static"
         v-bind:class="['m-level__bar--' + level.level]"></span>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getAllLevels']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/StaticLevels.vue